import styled from 'styled-components';

export const Drawer = styled.form`
  width: min(420px, 100vw);
  height: 100%;
  background: #fff;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  box-shadow: -12px 0 40px rgba(0, 0, 0, 0.15);
`;

export const Select = styled.select`
  height: 2.4rem;
  padding: 0 14px;
  border-radius: 2rem;
  border: 1px solid transparent;
  background: #f1f1f1;
  font-size: 13px;
  font-family: inherit;
  color: #2b2b2b;
  outline: none;

  &:focus {
    border-color: #0090d3;
    background: #fff;
  }
`;

export const DrawerFooter = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;
